export default "__VITE_ASSET__BZSo$XHH__"